import { render, staticRenderFns } from "./ProviderDelivery.vue?vue&type=template&id=854df076&"
import script from "./ProviderDelivery.vue?vue&type=script&lang=js&"
export * from "./ProviderDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports